var $ = require('jquery');

(function ($, window, document, undefined) {

    /*
     * DOCUMENT READY
     */

    $(document).ready(function () {

        /*
         * MOBILE NAVIGATION
         */

        var mobileNavigation = $('#mobile-navigation');
        var mainNavigation = $('#main-navigation');

        mobileNavigation.click(function () {
            mobileNavigation.toggleClass('active');
            if (mainNavigation.hasClass('active')) {
                mainNavigation.removeClass('show');
                mainNavigation.height();
                setTimeout(function () {
                    mainNavigation.removeClass('active');
                }, 400);
            } else {
                mainNavigation.addClass('active');
                mainNavigation.height();
                mainNavigation.addClass('show');
            }
        });

        /*
         * SLIDER
         */
        /*
        $('#slider').owlCarousel({
            items: 1,
            loop: true,
            nav: true,
            navText: ['', ''],
            smartSpeed: 400
        });
        */

        /*
         * CONTENT NAVIGATION
         */

        /**
         * Quick Search Toggle
         */
        var $quicksearch = $("#quickSearch");

        $("#quickSearchToggle").on("click", function () {
            $quicksearch.toggleClass("open");
            if($quicksearch.hasClass("open")) {
                $quicksearch.find('input[name="q"]').focus();
                $('html, body').animate({
                    scrollTop: 0
                }, 500);
            }
        });

        $(".navbar-toggler").on("click", function () {
            $quicksearch.removeClass("open");
        });

    });


    $("input.inputAutoWidth").keydown(function () {
        var $this = $(this);
        var $length = $this.val().length
        $this.width((($length + 1) * 12) + 4 + 'px');
    });

    $("input.inputAutoWidth").keyup(function () {
        var $this = $(this);
        var $length = $this.val().length
        if($length == 0) {
            $this.css("width", "");
        }
    });

})(jQuery, window, document);
